import classNames from "classnames";
import styles from "./styleComponent.module.scss";

export const BaseArrow = (props) => {
  const { children, className, onClick } = props;
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a className={`${styles.base_arrow} ${className}`} onClick={onClick}>
      {children}
    </a>
  );
};
export const ImageA = (props) => {
  const { children, active, className = "" } = props;
  return (

    <a
      {...props}
      className={`${styles.image_link} ${active ? styles.active_border : styles.no_border } ${className}`}
    >
      {children}
    </a>

  );
};
export const StyledSliderContiner = (props) => {
  const {
    fromSideMenu, isWebpImage = true, children, className = "",
  } = props;
  return (
    <div className={classNames(styles.image_slider_continer, className, {
      [styles.side_menu]: fromSideMenu,
      [styles.jpg_img_container]: !isWebpImage,
    })}
    >
      {children}
    </div>
  );
};
export const PrevA = (props) => {
  const { children } = props;
  return (
    <BaseArrow className={styles.prev_arrow}>
      {children}
    </BaseArrow>
  );
};

export const NextA = (props) => {
  const { children } = props;
  return (
    <BaseArrow className={styles.next_arrow}>
      {children}
    </BaseArrow>
  );
};
